/**
 * Import Dependency
 */
import axios from '@appservices/interceptor'

/**
 * Declare Variable
 */
const baseUrl = process.env.VUE_APP_API_URL

const getUrl = `${baseUrl}/admin/users`
const getMiscUrl = `${baseUrl}/admin/users/misc`
const saveStatusUrl = `${baseUrl}/admin/users/status`
const saveAdminUrl = `${baseUrl}/admin/users/admin`
const downloadUrl = `${baseUrl}/admin/users/download`
const deleteUrl = `${baseUrl}/admin/users/delete`
const byIdUrl = `${baseUrl}/admin/users/get`

/**
 * Export
 */
export default {
	get(data) {
		return axios.post(getUrl, data)
	},
	misc(data) {
		return axios.get(getMiscUrl, data)
	},
	status(data) {
		return axios.post(saveStatusUrl, data)
	},
	admin(data) {
		return axios.post(saveAdminUrl, data)
	},
	download(data) {
		return axios.post(downloadUrl, data)
	},
	delete(data) {
		return axios.post(deleteUrl, data)
	},
	getById(data) {
		return axios.post(byIdUrl, data)
	},
}